export default function () {
    const config = {
        nativeControlsForTouch: true // Native html5 player skin for mobile devices
    };

    return {
        restrict: 'A',
        link: (scope, element) => { // TODO: Separate controller from directive
            videojs(element[0], config, () => {
                // Player (this) is initialized and ready.
            });
        }
    };
}



// WEBPACK FOOTER //
// ./src/js/directives/mediaelement.js